/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Member_Seat_Type_ScheduledInputs */



/**
* | output |
* | --- |
* | "Seat type change scheduled" |
*
* @param {Audit_Details_Member_Seat_Type_ScheduledInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_member_seat_type_scheduled = /** @type {((inputs?: Audit_Details_Member_Seat_Type_ScheduledInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Member_Seat_Type_ScheduledInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sitztypänderung geplant")
	return /** @type {LocalizedString} */ ("Seat type change scheduled")
});